import { useEffect } from "react";
import * as Twilio from "@twilio/voice-sdk";
import axios from "axios";

let twilioDevice = null;

export const getTwilioDevice = () => twilioDevice;

export const useTwilioClient = (userId) => {
  useEffect(() => {
    const initTwilio = async () => {
      try {
        const { data } = await axios.get(
          `https://kz-ivr-api.onrender.com/ivr/token/${userId}`
        );
        const token = data.token;

        // Create and register Twilio Device
        twilioDevice = new Twilio.Device(token, {
          codecPreferences: ["opus", "pcmu"],
          logLevel: "info",
        });

        // 🔹 Register with Twilio signaling network
        await twilioDevice.register();

        console.log("✅ Twilio Device registered and ready");

        // Handle incoming call (from backend <Dial><Client>userId</Client>)
        twilioDevice.on("incoming", (call) => {
          console.log("📞 Incoming Twilio call:", call.parameters.From);
          call.accept();
        });

        twilioDevice.on("connect", () =>
          console.log("🔊 Call connected — audio should flow now")
        );

        twilioDevice.on("disconnect", () =>
          console.log("❌ Call disconnected")
        );

        twilioDevice.on("error", (error) =>
          console.error("⚠️ Twilio Error:", error)
        );
      } catch (err) {
        console.error("Failed to initialize Twilio device:", err);
      }
    };

    if (userId) initTwilio();

    return () => {
      if (twilioDevice) {
        twilioDevice.destroy();
        twilioDevice = null;
      }
    };
  }, [userId]);
};
